export class Feedback {
    Category: string;
    Comment: string;
}
